import clsx from 'clsx'

import styles from './SliderItem.module.scss'
import PlayIcon from '../../common/playIcon/PlayIcon'

interface SliderItemProps {
  img: string
  title: string
  isCenterSlide: boolean
  className?: string
  onPlay: () => void
  onClick?: () => void
}

const SliderItem = ({ img, title, isCenterSlide, className, onPlay, onClick }: SliderItemProps) => {
  return (
    <>
      <div className={clsx(styles.slide, className, isCenterSlide && styles.centerSlide)} onClick={onClick}>
        <div className={styles.imgContainer}>
          <div className={styles.imgOverlay} style={{ backgroundImage: `url(${img})` }} />
          {isCenterSlide && <PlayIcon className={styles.playIcon} hoverActive={true} onClick={onPlay} />}
        </div>
        <div className={styles.titleContainer}>
          <div
            className={isCenterSlide ? styles.activeTitle : styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      </div>
    </>
  )
}

export default SliderItem
